import { render, staticRenderFns } from "./AlertWithoutIcon.vue?vue&type=template&id=643790dc"
import script from "./AlertWithoutIcon.vue?vue&type=script&lang=js"
export * from "./AlertWithoutIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports